module.exports = "/templates/bds/public/font/23fbd7c6763eca9c0d6079b3c56c5b1f.woff2";